import styled from 'styled-components';

export const CurpBox = styled.div`
  margin-top: 8px;
  min-width: 0;

  label {
    display: block;
    font-size: var(--text-xs);
    font-weight: 700;
    color: var(--text-secondary);
    margin-bottom: 4px;
  }

  .curp-input {
    display: flex;
    gap: 8px;
    min-width: 0;
  }

  input {
    flex: 1;
    min-width: 0;
    padding: 11px 14px;
    background: var(--bg-input);
    border: 1.5px solid transparent;
    border-radius: var(--radius-md);
    color: var(--text-primary);
    font-family: var(--font-brand);
    font-size: var(--text-base);
    letter-spacing: 1px;
  }

  input:hover:not(:disabled) { border-color: var(--border-medium); }

  input:focus {
    outline: none;
    background: var(--white);
    border-color: var(--border-focus);
    box-shadow: 0 0 0 4px var(--focus-ring);
  }

  input[aria-invalid='true'] { border-color: var(--danger); }

  .reveal {
    flex-shrink: 0;
    border: 1.5px solid var(--border-medium);
    background: var(--white);
    color: var(--secondary);
    border-radius: var(--radius-md);
    padding: 0 14px;
    font-family: var(--font-brand);
    font-size: var(--text-sm);
    font-weight: 700;
    cursor: pointer;
  }

  .reveal:hover:not(:disabled) { border-color: var(--secondary); }

  .curp-hint {
    margin-top: 4px;
    font-size: var(--text-xs);
    color: var(--text-muted);
    line-height: 1.4;
  }

  .curp-hint.bad { color: var(--danger); font-weight: 600; }
  .curp-hint.good { color: var(--success-dark); font-weight: 600; }
`;

export const PrivacyBox = styled.div`
  background: var(--bg-section);
  border: 1px solid var(--border-light);
  border-left: 3px solid var(--secondary);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  margin: 14px 0;
  min-width: 0;

  h3 {
    font-size: var(--text-base);
    margin-bottom: 8px;
  }

  .notice-text {
    max-height: 190px;
    overflow-y: auto;
    font-size: var(--text-sm);
    color: var(--text-secondary);
    line-height: 1.55;
    padding-right: 4px;
  }

  .notice-text p + p { margin-top: 8px; }

  .accept {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid var(--border-light);
    font-size: var(--text-sm);
    font-weight: 600;
    color: var(--text-primary);
    cursor: pointer;
  }

  .accept input {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 1px;
    accent-color: var(--primary);
  }

  .draft {
    margin-top: 8px;
    font-size: var(--text-xs);
    color: var(--text-muted);
  }
`;

/* Ticket de venta: lo que se enseña o se manda al cliente. */
export const TicketCard = styled.article`
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  min-width: 0;

  .ticket-head {
    background: var(--bg-dark);
    color: var(--text-on-dark);
    padding: 18px 20px;
    text-align: center;
  }

  .ticket-head .eyebrow {
    display: block;
    font-size: var(--text-xs);
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: var(--text-on-dark-muted);
  }

  .ticket-head .number {
    font-size: var(--text-4xl);
    font-weight: 800;
    letter-spacing: -1px;
    line-height: 1.1;
  }

  .ticket-head .company {
    font-size: var(--text-sm);
    color: var(--text-on-dark-muted);
    overflow-wrap: anywhere;
  }

  .ticket-body { padding: 18px 20px; }

  .qr-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-bottom: 14px;
  }

  .qr-wrap img {
    width: 100%;
    max-width: 260px;
    height: auto;
    aspect-ratio: 1;
    background: var(--white);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-md);
    padding: 8px;
    image-rendering: pixelated;
  }

  .qr-note {
    font-size: var(--text-xs);
    color: var(--text-secondary);
    text-align: center;
    max-width: 320px;
    line-height: 1.45;
  }

  @media (max-width: 560px) {
    .ticket-body { padding: 16px; }
  }
`;

export const TicketActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-top: 16px;

  > * { flex: 1 1 160px; }

  @media (max-width: 560px) {
    > * { flex: 1 1 100%; }
  }
`;

export const AttendeeList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 0;
    font-size: var(--text-sm);
    min-width: 0;
  }

  .att-name { overflow-wrap: anywhere; min-width: 0; }
  .att-curp { color: var(--text-muted); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: var(--text-xs); white-space: nowrap; }
`;

/* Contador de entradas por actividad */
export const EntriesBox = styled.section`
  margin-top: 28px;
  min-width: 0;

  .entries-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    margin-bottom: 8px;
  }

  .entries-head h3 { margin: 0; }

  .entries-help {
    font-size: var(--text-xs);
    color: var(--text-muted);
    line-height: 1.45;
    margin-bottom: 12px;
  }

  .entries-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .entries-item {
    background: var(--bg-card);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-md);
    padding: 12px 14px;
    min-width: 0;
  }

  .entries-item.flash { border-color: var(--secondary); box-shadow: 0 0 0 3px var(--secondary-subtle); }

  .entries-title {
    font-weight: 700;
    overflow-wrap: anywhere;
    margin-bottom: 6px;
  }

  .entries-numbers {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 18px;
    font-size: var(--text-sm);
    color: var(--text-secondary);
  }

  .entries-numbers strong { color: var(--primary); font-size: var(--text-lg); }
  .entries-total { background: var(--primary-subtle); border-color: transparent; }
  .entries-empty { color: var(--text-secondary); font-size: var(--text-sm); }
`;
